import React, { useContext } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { messages } from '../LookupField.messages';
import { LookupOptionIcon } from './LookupOptionIcon';
export const LookupValue = ({
  data,
  selectProps: {
    customStyles,
    optionTypesMap
  }
}) => {
  const translator = useContext(TranslatorContext);
  const _ref = data || {},
    type = _ref.type,
    displayName = _ref.displayName;
  const _ref2 = optionTypesMap[type] || {},
    typeDisplayName = _ref2.typeDisplayName;
  const translatedTypeDisplayName = translator(typeDisplayName || messages.unknownType);
  return React.createElement("div", {
    className: customStyles.value
  }, React.createElement(LookupOptionIcon, {
    type: type,
    customStyles: customStyles,
    optionTypesMap: optionTypesMap,
    title: translatedTypeDisplayName
  }), React.createElement("div", {
    className: customStyles.title
  }, displayName));
};
LookupValue.__docgenInfo = {
  componentName: "LookupValue",
  packageName: "@jutro/components",
  description: "",
  displayName: "LookupValue",
  methods: [],
  actualName: "LookupValue"
};